import React from 'react';
const IntelliMarketingSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-intelliMarketing" });
IntelliMarketingSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-intelliMarketing sirius-icon-intelliMarketing-enhance" });
export default IntelliMarketingSvg;
